import React, { useState } from "react";
import {
  Box,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

import DriversReportTracker from "../DriversReport/DriversReportTracker/index";

const ActionsCell = ({ params }) => {
  const [openTrackDelivery, setOpenTrackDelivery] = useState(false);

  const hasActiveDelivery = params.row.total_pending_jobs > 0;

  const onTrackDeliveryClick = () => {
    setOpenTrackDelivery(true);
  };

  const handleCloseTrackDelivery = () => {
    setOpenTrackDelivery(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        height: "100%",
        minHeight: "52px",
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        sx={{
          backgroundColor: "#FAFAFA",
          borderRadius: "6px",
          border: "1px solid #E0E0E0",
          padding: "4px 8px",
          gap: 1,
        }}
      >
        <Tooltip title="Track Delivery">
          <Box
            display="flex"
            alignItems="center"
            gap={0.5}
            sx={{
              cursor: "pointer",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#E8F5E8",
                borderColor: "#C8E6C9",
              },
            }}
          >
            <Button
              startIcon={
                <LocalShippingIcon
                  sx={{
                    color: hasActiveDelivery ? "#388e3c" : "#919191ff",
                  }}
                />
              }
              disabled={!hasActiveDelivery}
              sx={{
                ml: 1,
                fontSize: "12px",
                fontWeight: 500,
                color: "#388e3c",
              }}
              onClick={onTrackDeliveryClick}
            >
              Track Active Delivery
            </Button>
          </Box>
        </Tooltip>
      </Box>

      {/* Track Delivery Modal */}
      <Dialog
        open={openTrackDelivery}
        onClose={handleCloseTrackDelivery}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>
          Delivery Route Tracker
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <DriversReportTracker driverId={params.row.id} />
        </DialogContent>
        <DialogActions
          sx={{
            p: 2,
          }}
        >
          <Button
            onClick={handleCloseTrackDelivery}
            variant="contained"
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ActionsCell;
